import { useState } from "react";
import { Tabs } from "@ofqual/portal-components/components/Tabs";
import { Paper } from "@material-ui/core";

type ItemTabsProps = {
  children: (activeTab: "current" | "previous") => React.ReactNode;
};

export const ItemTabs: React.FC<ItemTabsProps> = ({ children }) => {
  const [tabValue, setTabValue] = useState<"current" | "previous">("current");
  //const { userType } = useSelector(authSelector);
  //const isOfqual = userType === UserType.Ofqual;

  return (
    <>
      <Paper>
        <Tabs
          currentTabId={tabValue}
          onTabChange={(newTabId: any) => setTabValue(newTabId)}
          tabs={[
            {
              id: "current",
              label: <div style={{ display: "inline-flex" }}>Current&nbsp;</div>,
              dataTest: "current-tab",
            },
            {
              id: "previous",
              label: <div style={{ display: "inline-flex" }}>Previous&nbsp;</div>,
              dataTest: "previous-tab",
            },
          ]}
          indicatorColor="#085769"
          textColor="#085769"
        />
        {children(tabValue)}
      </Paper>
    </>
  );
};
